import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import productSlice from "./productSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";
import userSlice from "./userSlice";
import serviceSlice from "./serviceSlice";
import favouriteSlice from "./favouriteSlice";
import authSlice from "./authslice";



const persistConfig = {
  key: "root",
  storage,
   blacklist: ["auth"],
};

const rootReducer = combineReducers({
  favourite: favouriteSlice,
  products: productSlice,
  user: userSlice,
  service: serviceSlice,
 auth: authSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk], // You can add middleware here if needed
});

export const persistor = persistStore(store);
